import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import LookupGeneric from "./lookupGeneric";
import TaskStatusService from "../../src/Services/TaskStatus.service";
const TaskStatusLookup = (props) => {
    return LookupGeneric({
        onChange: props.onChange,
        // @ts-expect-error - TS2322 - Type 'number[]' is not assignable to type 'string[]'.
        defaultIds: props.defaultIds,
        labelKey: "label",
        // @ts-expect-error - TS2322 - Type '(ids: number[]) => Promise<TaskStatus[]>' is not assignable to type '(ids: string[]) => Promise<TaskStatus[]>'.
        fetchItemsById: (ids) => {
            return TaskStatusService.findByIds(ids);
        },
        fetchOptions: (search) => {
            return TaskStatusService.searchAll(search);
        },
        optionRenderer: function optionRenderer(taskStatus) {
            return _jsx("span", { children: taskStatus.label });
        },
    });
};
export default TaskStatusLookup;
